export default __webpack_public_path__ + "static/media/gouni-biology.b9fa6078.png";